import PageNotFound from './PageNotFound'
import enhance from './PageNotFound.enhancer'

export default enhance(PageNotFound)



// WEBPACK FOOTER //
// ./src/containers/account/PageNotFound/index.js